{
  "title": "Evaluation Details",
  "description": "View detailed information about this evaluation",
  "backToPatient": "Back to Patient",
  "notFound": "Evaluation not found",
  "notFoundDescription": "The evaluation you're looking for doesn't exist or has been removed",
  "evaluationInfo": "Evaluation Information",
  "evaluationInfoDescription": "General information about this evaluation",
  "patientInfo": "Patient Information",
  "category": "Category",
  "status": "Status",
  "duration": "Duration",
  "createdAt": "Created",
  "updatedAt": "Last Updated",
  "startedAt": "Started at",
  "endedAt": "Ended at",
  "notCompleted": "Not completed",
  "patientName": "Patient Name",
  "patientEmail": "Email",
  "patientBirthDate": "Birth Date",
  "notes": "Notes",
  "evaluationData": "Evaluation Data",
  "evaluationDataDescription": "Detailed evaluation results and analysis",
  "detailedDataComingSoon": "Detailed evaluation data visualization coming soon",
  "admin": {
    "title": "Evaluations",
    "description": "Manage evaluation modules, categories, scales, and questions for assessments",
    "tabs": {
      "modules": "Modules",
      "scales": "Scales"
    },
    "common": {
      "cancel": "Cancel",
      "save": "Save",
      "create": "Create",
      "update": "Update",
      "delete": "Delete",
      "edit": "Edit",
      "view": "View",
      "add": "Add",
      "loading": "Loading...",
      "creating": "Creating...",
      "updating": "Updating...",
      "deleting": "Deleting...",
      "searchPlaceholder": "Search...",
      "noResults": "No results found",
      "noResultsSearch": "No results found matching your search",
      "actions": "Actions",
      "active": "Active",
      "inactive": "Inactive",
      "created": "Created",
      "order": "Order",
      "selectOption": "Select an option",
      "openMenu": "Open menu"
    },
    "modules": {
      "title": "Edit Module",
      "description": "Update module information and settings.",
      "addTitle": "Add New Module",
      "addDescription": "Create a new evaluation module with categories and questions.",
      "editTitle": "Edit Module",
      "editDescription": "Update module information and settings.",
      "viewTitle": "Module Details",
      "deleteTitle": "Delete Module",
      "deleteDescription": "Are you sure you want to delete this module?",
      "deleteConfirm": "This action cannot be undone and will remove all associated categories and questions.",
      "searchPlaceholder": "Search modules...",
      "createFirst": "Please create a module first to manage questions.",
      "form": {
        "title": "Title",
        "titlePlaceholder": "Enter module title",
        "code": "Code",
        "codePlaceholder": "MODULE_CODE",
        "description": "Description",
        "descriptionPlaceholder": "Enter module description",
        "image": "Image (Optional)",
        "imagePlaceholder": "Upload an image",
        "isActive": "Active",
        "isActiveDescription": "Enable this module for evaluations"
      },
      "deleteDialogTitle": "Delete Module",
      "deleteDialogDescription": "Are you sure you want to delete \"{{title}}\"? This action cannot be undone and will remove all associated categories and questions.",
      "deleteButton": "Delete Module",
      "deletingButton": "Deleting...",
      "deleteSuccessMessage": "Module deleted successfully",
      "deleteErrorMessage": "Failed to delete module",
      "updateSuccessMessage": "Module updated successfully",
      "updateErrorMessage": "Failed to update module",
      "createSuccessMessage": "Module created successfully",
      "createErrorMessage": "Failed to create module",
      "table": {
        "searchPlaceholder": "Search modules...",
        "addButton": "Add Module",
        "headers": {
          "title": "Title",
          "code": "Code",
          "categories": "Categories",
          "questions": "Questions",
          "status": "Status",
          "created": "Created",
          "actions": "Actions"
        },
        "loading": "Loading modules...",
        "noResults": "No modules found.",
        "noResultsSearch": "No modules found matching your search.",
        "status": {
          "active": "Active",
          "inactive": "Inactive"
        }
      }
    },
    "scales": {
      "title": "Evaluation Scales",
      "description": "Manage scoring scales with custom options and values",
      "addTitle": "Add New Scale",
      "addDescription": "Create a new evaluation scale with custom options and values.",
      "editTitle": "Edit Scale",
      "editDescription": "Update scale information and options.",
      "viewTitle": "Scale Details",
      "deleteTitle": "Delete Scale",
      "deleteDescription": "Are you sure you want to delete this scale?",
      "deleteConfirm": "This action cannot be undone and will affect all questions using this scale.",
      "searchPlaceholder": "Search scales...",
      "comingSoon": "Scales management interface coming soon...",
      "form": {
        "label": "Scale Label",
        "labelPlaceholder": "Enter scale label",
        "code": "Scale Code",
        "codePlaceholder": "SCALE_CODE",
        "options": "Scale Options",
        "optionLabel": "Label",
        "optionValue": "Value",
        "optionLabelPlaceholder": "Option label",
        "optionValuePlaceholder": "0",
        "addOption": "Add Option",
        "preview": "Preview:",
        "uniqueValuesError": "All option values must be unique",
        "defaultOptions": {
          "poor": "Poor",
          "fair": "Fair",
          "good": "Good",
          "excellent": "Excellent"
        },
        "optionLabelLabel": "Label",
        "optionValueLabel": "Value",
        "addOptionButton": "Add Option",
        "previewLabel": "Preview:",
        "uniqueValuesErrorMessage": "All option values must be unique"
      },
      "createSuccessMessage": "Scale created successfully",
      "createErrorMessage": "Failed to create scale",
      "table": {
        "searchPlaceholder": "Search scales...",
        "addButton": "Add Scale",
        "headers": {
          "label": "Label",
          "code": "Code",
          "options": "Options",
          "questions": "Questions",
          "created": "Created",
          "actions": "Actions"
        },
        "loading": "Loading scales...",
        "noResults": "No scales found.",
        "noResultsSearch": "No scales found matching your search.",
        "option": "Option {{index}}",
        "more": "+{{count}} more"
      },
      "viewDescription": "View scale information and options.",
      "deleteDialogTitle": "Delete Scale",
      "deleteDialogDescription": "Are you sure you want to delete \"{{label}}\"? This action cannot be undone and will affect all questions using this scale.",
      "deleteButton": "Delete Scale",
      "deletingButton": "Deleting...",
      "deleteSuccessMessage": "Scale deleted successfully",
      "deleteErrorMessage": "Failed to delete scale",
      "updateSuccessMessage": "Scale updated successfully",
      "updateErrorMessage": "Failed to update scale"
    },
    "questions": {
      "title": "Evaluation Questions",
      "description": "Manage questions with drag-and-drop ordering and auto-generated codes",
      "addTitle": "Add New Question",
      "addDescription": "Create a new question with auto-generated code.",
      "editTitle": "Edit Question",
      "editDescription": "Update question information and settings.",
      "viewTitle": "Question Details",
      "deleteTitle": "Delete Question",
      "deleteDescription": "Are you sure you want to delete this question?",
      "deleteConfirm": "This action cannot be undone.",
      "searchPlaceholder": "Search questions...",
      "groupedBy": "Questions grouped by category:",
      "categories": "categories",
      "form": {
        "question": "Question",
        "questionPlaceholder": "Enter question text",
        "hint": "Hint (Optional)",
        "hintPlaceholder": "Enter helpful hint",
        "category": "Category",
        "scale": "Scale",
        "code": "Question Code",
        "orderIndex": "Order"
      },
      "table": {
        "searchPlaceholder": "Search questions...",
        "addButton": "Add Question",
        "headers": {
          "question": "Question",
          "category": "Category",
          "scale": "Scale",
          "order": "Order",
          "created": "Created",
          "actions": "Actions"
        },
        "loading": "Loading questions...",
        "noResults": "No questions found.",
        "noResultsSearch": "No questions found matching your search.",
        "groupedBy": "Questions grouped by category:",
        "categories": "categories"
      },
      "viewDescription": "View question information and settings.",
      "deleteDialogTitle": "Delete Question",
      "deleteDialogDescription": "Are you sure you want to delete this question? This action cannot be undone.",
      "deleteButton": "Delete Question",
      "deletingButton": "Deleting...",
      "deleteSuccessMessage": "Question deleted successfully",
      "deleteErrorMessage": "Failed to delete question",
      "updateSuccessMessage": "Question updated successfully",
      "updateErrorMessage": "Failed to update question",
      "createSuccessMessage": "Question created successfully",
      "createErrorMessage": "Failed to create question"
    },
    "categories": {
      "title": "Categories",
      "description": "Manage hierarchical categories with tree-like path structures",
      "addTitle": "Add New Category",
      "addDescription": "Create a new category with hierarchical path structure.",
      "editTitle": "Edit Category",
      "editDescription": "Update category information and path structure.",
      "viewTitle": "Category Details",
      "deleteTitle": "Delete Category",
      "deleteDescription": "Are you sure you want to delete this category?",
      "deleteConfirm": "This action cannot be undone and will remove all associated questions.",
      "searchPlaceholder": "Search categories...",
      "form": {
        "label": "Category Label",
        "labelPlaceholder": "Enter category label",
        "parent": "Parent Category",
        "parentPlaceholder": "Select parent category...",
        "slug": "Slug",
        "slugPlaceholder": "category-identifier",
        "pathSegments": "Category Path",
        "pathPlaceholder": "Enter path segment",
        "pathPreview": "Full Path Preview:",
        "path": "Path",
        "depth": "Depth:",
        "addLevel": "Add Level",
        "isActive": "Active",
        "isActiveDescription": "Enable this category for evaluations",
        "depthLabel": "Depth:",
        "pathPreviewTitle": "Full Path Preview:",
        "rootLevel": "Root level"
      },
      "createSuccessMessage": "Category created successfully",
      "createErrorMessage": "Failed to create category",
      "table": {
        "searchPlaceholder": "Search categories...",
        "addButton": "Add Category",
        "headers": {
          "label": "Label",
          "path": "Path",
          "depth": "Depth",
          "questions": "Questions",
          "status": "Status",
          "created": "Created",
          "actions": "Actions"
        },
        "loading": "Loading categories...",
        "noResults": "No categories found.",
        "noResultsSearch": "No categories found matching your search.",
        "status": {
          "active": "Active",
          "inactive": "Inactive"
        }
      },
      "viewDescription": "View category information and statistics.",
      "deleteDialogTitle": "Delete Category",
      "deleteDialogDescription": "Are you sure you want to delete \"{{label}}\"? This action cannot be undone and will remove all associated questions.",
      "deleteButton": "Delete Category",
      "deletingButton": "Deleting...",
      "deleteSuccessMessage": "Category deleted successfully",
      "deleteErrorMessage": "Failed to delete category",
      "updateSuccessMessage": "Category updated successfully",
      "updateErrorMessage": "Failed to update category"
    },
    "recommendations": {
      "title": "Recommendations",
      "description": "Manage recommendations for different categories and modalities",
      "add": "Add Recommendation",
      "edit": "Edit Recommendation",
      "view": "View Recommendation",
      "delete": "Delete Recommendation",
      "loading": "Loading recommendations...",
      "searchPlaceholder": "Search by category or modality...",
      "foundResults": "{{count}} recommendation(s) found",
      "noResults": "No recommendations found",
      "confirmDelete": "Are you sure you want to delete this recommendation?",
      "deleteWarning": "This action cannot be undone.",
      "fields": {
        "category": "Category",
        "modality": "Modality",
        "shortContent": "Short Content",
        "deepContent": "Deep Content",
        "thresholdMin": "Minimum Threshold",
        "thresholdMax": "Maximum Threshold"
      },
      "placeholders": {
        "selectCategory": "Select a category",
        "shortContent": "Enter short content for the recommendation",
        "deepContent": "Enter detailed content for the recommendation",
        "thresholdMin": "Minimum threshold value",
        "thresholdMax": "Maximum threshold value"
      },
      "actions": {
        "save": "Save",
        "cancel": "Cancel",
        "delete": "Delete",
        "close": "Close"
      },
      "table": {
        "category": "Category",
        "modality": "Modality",
        "shortContent": "Short Content",
        "thresholds": "Thresholds",
        "actions": "Actions",
        "min": "Min",
        "max": "Max"
      },
      "addSheetDescription": "Create a new recommendation for a specific category and modality.",
      "editSheetDescription": "Update the recommendation details below.",
      "viewSheetDescription": "View recommendation details and content.",
      "idLabel": "ID",
      "messages": {
        "createSuccess": "Recommendation created successfully",
        "updateSuccess": "Recommendation updated successfully",
        "deleteSuccess": "Recommendation deleted successfully",
        "createError": "Error creating recommendation",
        "updateError": "Error updating recommendation",
        "deleteError": "Error deleting recommendation"
      }
    },
    "moduleView": {
      "title": "Module Details",
      "description": "Module details and statistics",
      "fields": {
        "code": "Code",
        "description": "Description",
        "status": "Status",
        "categories": "Categories",
        "questions": "Questions",
        "created": "Created",
        "image": "Image"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      }
    },
    "moduleDetails": {
      "title": "Module Details",
      "description": "Manage categories, questions, and recommendations for this evaluation module",
      "breadcrumb": {
        "evaluations": "Evaluations",
        "moduleDetails": "Module Details"
      },
      "sections": {
        "overview": "Overview",
        "categories": "Categories",
        "questions": "Questions & Recommendations"
      },
      "overview": {
        "title": "Module Information",
        "fields": {
          "code": "Code",
          "description": "Description",
          "status": "Status",
          "created": "Created",
          "image": "Image",
          "totalCategories": "Total Categories",
          "totalQuestions": "Total Questions"
        },
        "status": {
          "active": "Active",
          "inactive": "Inactive"
        },
        "actions": {
          "edit": "Edit Module",
          "viewQuestions": "View All Questions"
        }
      },
      "categories": {
        "title": "Categories",
        "description": "Click on a category to view its questions and recommendations",
        "addCategory": "Add Category",
        "noCategories": "No categories found for this module",
        "createFirst": "Create your first category to organize questions",
        "card": {
          "questions": "questions",
          "recommendations": "recommendations",
          "depth": "Depth {{depth}}",
          "path": "Path: {path}",
          "inactive": "Inactive"
        }
      },
      "questions": {
        "title": "Questions & Recommendations",
        "description": "Manage questions and recommendations with advanced search and filtering",
        "filterByCategory": "Filter by Category",
        "allCategories": "All Categories",
        "tabQuestions": "Questions",
        "tabRecommendations": "Recommendations",
        "noQuestions": "No questions found for this category",
        "addQuestion": "Add Question",
        "categoryRecommendations": "Recommendations for {{categoryName}}",
        "noRecommendations": "No recommendations found for this category",
        "addRecommendation": "Add Recommendation"
      },
      "actions": {
        "back": "Back to Evaluations",
        "edit": "Edit",
        "view": "View",
        "delete": "Delete",
        "add": "Add"
      }
    }
  },
  "success": {
    "createCategorySuccess": "Category created successfully",
    "createCategorySuccessDescription": "The category has been added to the module",
    "createModuleSuccess": "Module created successfully",
    "createModuleSuccessDescription": "The module has been added to your list",
    "createQuestionSuccess": "Question created successfully",
    "createQuestionSuccessDescription": "The question has been added to the category",
    "createRecommendationSuccess": "Recommendation created successfully",
    "createRecommendationSuccessDescription": "New recommendation has been added",
    "createScaleSuccess": "Scale created successfully",
    "createScaleSuccessDescription": "The scale is now available globally",
    "deleteCategorySuccess": "Category deleted successfully",
    "deleteModuleSuccess": "Module deleted successfully",
    "deleteQuestionSuccess": "Question deleted successfully",
    "deleteRecommendationSuccess": "Recommendation deleted successfully",
    "deleteScaleSuccess": "Scale deleted successfully",
    "reorderQuestionsSuccess": "Questions reordered successfully",
    "updateCategorySuccess": "Category updated successfully",
    "updateModuleSuccess": "Module updated successfully",
    "updateQuestionSuccess": "Question updated successfully",
    "updateRecommendationSuccess": "Recommendation updated successfully",
    "updateScaleSuccess": "Scale updated successfully",
    "changesSaved": "Changes have been saved"
  },
  "errors": {
    "createCategoryFailed": "Failed to create category",
    "createModuleFailed": "Failed to create module",
    "createQuestionFailed": "Failed to create question",
    "createRecommendationFailed": "Failed to create recommendation",
    "createScaleFailed": "Failed to create scale",
    "deleteCategoryFailed": "Failed to delete category",
    "deleteModuleFailed": "Failed to delete module",
    "deleteQuestionFailed": "Failed to delete question",
    "deleteRecommendationFailed": "Failed to delete recommendation",
    "deleteScaleFailed": "Failed to delete scale",
    "getEvaluationDetailsFailed": "Failed to load evaluation details",
    "getEvaluationsFailed": "Failed to load evaluations",
    "loadCategoriesTreeFailed": "Failed to load categories tree",
    "loadCategoriesFailed": "Failed to load categories",
    "loadModuleFailed": "Failed to load module",
    "loadModulesFailed": "Failed to load modules",
    "loadMonthlyCountFailed": "Failed to load monthly evaluation count",
    "loadQuestionFailed": "Failed to load question",
    "loadQuestionsFailed": "Failed to load questions",
    "loadRecommendationsFailed": "Failed to load recommendations",
    "loadScaleFailed": "Failed to load scale",
    "loadScalesFailed": "Failed to load scales",
    "reorderQuestionsFailed": "Failed to reorder questions",
    "updateCategoryFailed": "Failed to update category",
    "updateModuleFailed": "Failed to update module",
    "updateQuestionFailed": "Failed to update question",
    "updateRecommendationFailed": "Failed to update recommendation",
    "updateScaleFailed": "Failed to update scale",
    "checkInfoAndRetry": "Please check your information and try again",
    "tryAgainLater": "Please try again later",
    "tryRefreshing": "Please try refreshing the page"
  }
}
